import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(phoneVerificationOnEnterSaga);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { scrollToTop } from 'redux/saga/helpers';
import { userNeedsPhoneVerification } from 'features/PhoneVerification/PhoneVerification.saga'; // redirects to the signup URL for this item if you are not logged in
// redirects to the purchase URL for this item if you are already verified

export function phoneVerificationOnEnterSaga(client, nextState, replaceState) {
  var loggedIn, needsVerification;
  return regeneratorRuntime.wrap(function phoneVerificationOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          loggedIn = _context.sent;
          _context.next = 5;
          return call(scrollToTop);

        case 5:
          if (loggedIn) {
            _context.next = 9;
            break;
          }

          _context.next = 8;
          return call(replaceState, _objectSpread({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/verify-phone/, '/signup')
          }));

        case 8:
          return _context.abrupt("return");

        case 9:
          _context.next = 11;
          return call(userNeedsPhoneVerification, client);

        case 11:
          needsVerification = _context.sent;

          if (needsVerification) {
            _context.next = 15;
            break;
          }

          _context.next = 15;
          return call(replaceState, _objectSpread({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/verify-phone/, '/purchase')
          }));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}